var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "container", staticClass: "muti-ellipsis" }, [
    !_vm.clientIsIe
      ? _c(
          "div",
          {
            staticClass: "ellipsis-webkit-type",
            style: !_vm.isComplate && _vm.webkitStyle,
          },
          [
            _c("div", { style: _vm.txtStyle, attrs: { title: _vm.text } }, [
              _vm._v(_vm._s(_vm.text)),
            ]),
          ]
        )
      : _c(
          "div",
          { staticClass: "ellipsis-ie-type", attrs: { title: _vm.text } },
          [
            _c(
              "div",
              {
                staticClass: "muti-ellipsis-content",
                style: _vm.setFontSizeNormal(),
              },
              [
                _c("span", { ref: "text", style: _vm.txtStyle }, [
                  _vm._v(" " + _vm._s(_vm.textFat.viewText) + " "),
                  _vm.showSuffix && !_vm.isComplate
                    ? _c(
                        "span",
                        {
                          staticClass: "muti-ellipsis-content-more",
                          style: _vm.getMoreStyle(),
                        },
                        [_vm._v(_vm._s(_vm.more))]
                      )
                    : _vm._e(),
                ]),
                _c("transition", { attrs: { name: "ellipsis-slide" } }, [
                  _vm.isComplate
                    ? _c("span", { staticClass: "more", style: _vm.txtStyle }, [
                        _vm._v(_vm._s(_vm.textFat.moreText)),
                      ])
                    : _vm._e(),
                ]),
              ],
              1
            ),
          ]
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }